import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appDateOfBirth]'
})
export class DateOfBirthDirective {

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event: Event) {
    const initialValue: string = this.el.nativeElement.value;
    const formattedValue: string = initialValue
      .replace(/\D/g, '') // Remove non-numeric characters
      .slice(0, 8) // Limit to 8 digits for yyyyMMdd
      .replace(/^(\d{4})(\d{2})(\d{2})$/, '$1-$2-$3') // Format as yyyy-MM-dd
      .replace(/(\d{4})-(\d{2})-(\d{2})/, (match, year, month, day) => {
        // Ensure month is between 01 and 12
        const formattedMonth = Math.min(parseInt(month, 10), 12).toString().padStart(2, '0');
        // Ensure day is between 01 and 31
        const formattedDay = Math.min(parseInt(day, 10), 31).toString().padStart(2, '0');
        return `${year}-${formattedMonth}-${formattedDay}`;
      });
  
    if (initialValue !== formattedValue) {
      this.el.nativeElement.value = formattedValue;
      event.stopPropagation(); // Prevent default input behavior
    }
  }

  

}
